<template>
  <section class="edit-policy">
    <section
      v-show="!isNext"
      class="flex ">
      <section
        :class="{
          'width-remark-content':ticketId
        }">
        <section class="flex-sb-center">
          <h2>{{ isCancel? 'Cancel': 'Edit' }} Policy</h2>
          <div class="flex">
            <v-button @click="handlerCancel">Cancel</v-button>
            <v-button
              type="primary"
              @click="clickNext">Next</v-button>
          </div>
        </section>
        <policy-form
          ref="policy-form"
          :isCancel="isCancel"
          :form="formData"
          :action="action"
          :occData="occData"
          :isEndorsement="isEndorsement"
          :disabledList="['trm_of_cvr', 'usage_ind']"
          @submit="getSubmitForm" />
      </section>
      <template v-if="!isNext&&!!ticketId">
        <ticket-remark :ticket-id="ticketId"></ticket-remark>
      </template>
    </section>
    <section  v-show="isNext">
      <template>
        <h2>{{ isCancel? 'Cancel': 'Edit' }} Policy</h2>
        <span v-if="isRefer && isNext">New premium could not be calculated automatically, please enter manually.</span>
      </template>
      <div class="abs-top-right">
        <!-- mock -->
        <template v-if="mock">
          <section v-if="!isNext">
            <v-button @click="onMockBack">Back</v-button>
            <v-button
              type="primary"
              @click="handlerNext">Next</v-button>
          </section>
          <section v-else>
            <v-button @click="onMockBack">Back</v-button>
            <v-button
              type="primary"
              @click="onMockDone">Done</v-button>
          </section>
        </template>
        <template v-else>
          <section v-if="!isNext">
            <v-button @click="handlerCancel">Cancel</v-button>
            <v-button
              type="primary"
              @click="clickNext">Next</v-button>
          </section>
          <section v-else>
            <v-button @click="onBack">Back</v-button>
            <v-button
              type="info"
              @click="clickSave">{{ isEndorsementDraft? 'Save': 'Save Draft' }}</v-button>
            <v-button
              type="primary"
              @click="clickDeliver">Deliver</v-button>
          </section>
        </template>
      </div>
    </section>
    <endorsement-info
      v-show="isNext"
      ref="endorsement-info"
      :mock="mock"
      :isRefer="isRefer"
      :isCancel="isCancel"
      :form="resultForm"
      :oldForm="oldForm"
      :premiumData="premiumData"
      :orderId="orderId"
      :isNext="isNext"
      :isBeginEndorsement="isBeginEndorsement"
      @get-payable="changeDiffPayble"
      @updateCancelPremium="handleCancelUpdatePremium"
      @get-handlingfee="changeHandlingFee"
      @get-quote="handlerGetQuoteUpdate"
      @getFormData="getPremiumForm" />


    <lazy-dom notLoading>
      <use-personal-data
        ref="use-personal-data"
        :marketing_data="formData.marketing_data"
        :company_name="formData.company_language"
        @sendData="getData"></use-personal-data>
    </lazy-dom>

    <!-- dialog -->
    <deliver-dialog
      ref="deliver-dialog"
      :isCancel="isCancel"
      :submitFormData="submitFormData"
      :cancelParams="cancelParams"
      :dialogType="dialogType"
      @done="handlerDeliverDone" />

    <set-void-quote
      ref="void-dialog"
      :orderId="orderId"
      :refund="diffPayable"
      :is-normal="false"
      :type="1"
      @setVoid="handlerVoid"
    >
    </set-void-quote>

    <send-email-sms
      ref="send-email-sms"
      :form="form"
      :initContent="form.modify_quotation_url_data"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      @send="handlerSend"
      @skip="handlerSkip" />


  </section>
</template>
<script>
import PolicyForm from './form/policy-form'
import EndorsementInfo from './endorsement-info'
import DeliverDialog from '../dialogs/deliver-dialog'
import setVoidQuote from '@/views/components/set-void-quote'
import dayjs from 'dayjs'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'
import {
  deliverEndorsement,
  editEndorsementQuote,
  getCancelQuoteResult,
  getEndorsementQuoteResult,
  saveCancelQuote,
  saveEndorsementQuote
} from '@/api/endorsement'
import UsePersonalData from '@/views/components/use-personal-data'
import TicketRemark from '@/views/tickets/components/ticket-remark'

export default {
  name: 'EditPolicy',
  components: {
    TicketRemark,
    PolicyForm,
    EndorsementInfo,
    DeliverDialog,
    setVoidQuote,
    SendEmailSms,
    UsePersonalData
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    occData: {
      type: Object,
      default: () => ({})
    },
    relationForm: {
      type: Object,
      default: () => ({})
    },
    mock: {
      type: Boolean,
      default: false
    },
    ticketId: {
      type: [String, Number],
      default: ''
    },
    // isEditEndorsementDraft: {
    //   type: Boolean,
    //   default: false
    // },
    endorseOrderId: {
      type: [String, Number],
      default: 0
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    action: {
      type: [String, Number],
      default: 1 // 1 - endorse, 2 - cancel
    },
    isBeginEndorsement: {
      type: Boolean,
      default: false
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    renewOrderSn:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isNext: false,
      isRefer: false,
      deliverDialog: false,
      formData: {},
      oldForm: {},
      resultForm: {},
      premiumData: {
        diff_payable: {},
        new_premium: {},
        old_premium: {},
        extra_benefits_premium: {},
        type: 1,
        is_manual_quote: 0
      },
      dialogType: 0, // normal、refund、no difference
      diffPayable: 0, // 两次投保差额
      handlingFee: 0, // 手續費
      premiumInfo: {},
      submitFormData: {},
      content: '',
      is_send: 0,
      cancelData: {},
      personalData: {}
    }
  },
  computed: {
    // orderId() {
    //   return this.form.id
    // },
    emailTitle(){
      return this.form.modify_quotation_title || ''
    },
    emailListTitle(){
      return this.form.modify_quotation_list_title || ''
    },

    isEndorsementDraft() {
      return this.endorseOrderId > 0
    },
    isCancel() {
      return this.action != 1
    },
    cancelParams() {
      return {
        ticket_id: this.ticketId,
        order_id: this.orderId,
        pcy_cmnt_dt: this.resultForm.pcy_cmnt_dt,
        pcy_expry_dt: this.resultForm.pcy_expry_dt,
        handling_fee: this.handlingFee
      }
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = JSON.parse(JSON.stringify(val))
      }
    },
    relationForm: {
      immediate: true,
      deep: true,
      handler(val) {
        this.oldForm = JSON.parse(JSON.stringify(val))
        this.oldForm.isrd_dob = dayjs(this.oldForm.isrd_dob).format('YYYY-MM-DD')
      }
    },
    occData:{
      immediate: true,
      deep: true,
      handler(val) {
        if(val)
          this.formData.isrd_dob_date = val&&val.isrd_dob_date
      }
    }
  },
  methods: {
    initData() {
      this.isNext = false
      this.isRefer = false
    },
    onBack() {
      if(!this.mock) {
        this.isNext = false
      }
    },
    onMockBack() {
      if(this.isNext) {
        this.isNext = false
      }
      else {
        this.$emit('back')
      }
    },
    onMockDone() {
      this.$emit('done')
    },
    changeDiffPayble(payable) {
      this.diffPayable = payable
    },
    changeHandlingFee(handlingFee) {
      this.handlingFee = handlingFee
    },
    handleCancelUpdatePremium(val, type){
      this.cancelData = val
      if(!type){
        let params = {
          order_id: this.orderId,
          ticket_id: this.ticketId,
          pcy_cmnt_dt: this.resultForm.pcy_cmnt_dt,
          pcy_expry_dt: this.resultForm.pcy_expry_dt,
        }
        Object.assign(params, val)

        this.network().getCancelQuoteResult(params)
      }
    },
    handlerDeliverDone() {
      this.$emit('save')
    },
    clickNext(){
      // this.handleUpdate()
      if(this.renewOrderSn){
        this.$emit('nextStep', 2)
      }else{
        this.handlerNext()
      }
    },
    handlerNext() {
      // 獲取數據
      this.$refs['policy-form'].submitForm()
    },
    handleUpdate(){
      this.$emit('update')
    },
    nextStep(step){
      this.$emit('nextStep', step)
    },
    getSubmitForm(formData) {
      this.resultForm = JSON.parse(JSON.stringify(formData))
      //取消则返回上一信息
      if(this.isCancel) {
        // cancel 單
        this.network().getCancelQuoteResult({
          order_id: this.orderId,
          ticket_id: this.ticketId,
          pcy_cmnt_dt: formData.pcy_cmnt_dt,
          pcy_expry_dt: formData.pcy_expry_dt,
        })
      }
      else {
        this.network().getEndorsementQuoteResult(formData)
      }
    },
    handlerGetQuoteUpdate(premiumForm) {
      let data = JSON.parse(JSON.stringify(this.resultForm))
      const params = Object.assign(data, premiumForm)
      this.network().getEndorsementQuoteResult({
        get_quote_main: 1, // refer
        ...params
      })
    },
    // 獲取 endorsement info 的數據
    getPremiumForm(premium, type, otherForm = {}) {
      this.resultForm.plan_id = premium.plan_id
      this.premiumInfo = premium
      premium.benefits = JSON.parse(JSON.stringify(this.resultForm.benefits))
      premium.benefit_coverage = JSON.parse(JSON.stringify(this.resultForm.benefit_coverage))
      premium.benefit_sort = JSON.parse(JSON.stringify(this.resultForm.benefit_sort))
      // 拼接調用 save 接口
      const params = {
        premium,
        application: {
          ...this.resultForm,
          order_id: this.orderId,
          ticket_id: this.ticketId,
          ...otherForm,
          is_manual_quote: premium.is_manual_quote,
          benefit_premium: premium.benefit_premium
        }
      }
      if(this.isEndorsementDraft) {
        params.application.endorse_order_id = this.endorseOrderId // 改單 id
        params.application.plan_id = this.resultForm.quote_coverage_list.plan_info.plan_id||''
        if(this.premiumData.new_premium){
          this.$set(params.application, 'new_remaining_days', this.premiumData.new_premium.remaining_days)
          this.$set(params.application, 'new_cycle', this.premiumData.new_premium.cycle)
          this.$set(params.application, 'new_remaining_day_rate', this.premiumData.new_premium.remaining_day_rate)
          this.$set(params.application, 'old_remaining_days', this.premiumData.old_premium.remaining_days)
          this.$set(params.application, 'old_cycle', this.premiumData.old_premium.cycle)
          this.$set(params.application, 'old_remaining_day_rate', this.premiumData.old_premium.remaining_day_rate)
          this.$set(params.application, 'remaining_premium', this.premiumData.old_premium.remaining_premium)
        }
      }
      this.$set(params.application, 'extra_benefits_content', this.premiumData.extra_benefits_premium)
      this.submitFormData = params
      // save draft
      if(type === 'save') {
        if(this.isCancel) {
          this.$refs['endorsement-info'].$refs['premium-form-endorsement'].updatePremium('save')
          this.network().saveCancelQuote({
            type: 1,
            ...otherForm,
            ...this.cancelData
          })
        }
        else if(this.isEndorsementDraft) {
          this.network().editEndorsementQuote(params)
        } else {
          this.network().saveEndorsementQuote(params)
        }
      }
      // deliver
      else {
        this.handlerDeliver()
      }
    },
    handlerCancel() {
      this.$emit('cancel')
    },
    clickSave(){
      if(this.renewOrderSn){
        this.$emit('nextStep', 3)
      }else{
        this.handlerSaveDraft()
      }
    },
    handlerSaveDraft() {
      this.$refs['endorsement-info'].submitForm('save')
      // 調用 draft 接口
      // this.initData()
      // this.$emit('close')
    },
    handlerSend(content) {
      this.content = content
      this.is_send = 1
      this.$refs['endorsement-info'].submitForm('deliver')
    },
    handlerSkip() {
      this.content = ''
      this.is_send = 0
      this.$refs['endorsement-info'].submitForm('deliver')
    },
    clickDeliver(){
      if(this.renewOrderSn){
        this.$emit('nextStep', 4)
      }else{
        this.onDeliver()
      }
    },
    onDeliver() {
      this.$refs['send-email-sms'].changeDialog()
    },
    handlerDeliver(content) {
      //  調用接口判斷顯示哪個彈窗
      // dialogType = 0- normal、refund、no difference

      if(this.isCancel) {
        // cancel 和 endorse 不一樣， refund 大於 0 才是退款
        if(this.diffPayable == 0) {
          this.dialogType = 2
          this.$refs['endorsement-info'].$refs['premium-form-endorsement'].updatePremium('save')
          this.network().saveCancelQuote({
            type: 2,
            ...this.cancelData
          })
        }
        else if(this.diffPayable > 0) {
          this.dialogType = 1
          // this.$refs['deliver-dialog'].changeDialog()
          this.$refs['void-dialog'].changeDialog(this.diffPayable)
        }
        else {
          this.dialogType = 0
          this.$refs['endorsement-info'].$refs['premium-form-endorsement'].updatePremium('save')
          this.network().saveCancelQuote({
            type: 2,
            ...this.cancelData
          })
        }
      } else {
        if(this.diffPayable == 0) {
          this.dialogType = 2
          this.network().deliverEndorsement()
        }
        else if(this.diffPayable < 0) {
          this.dialogType = 1
          this.$refs['void-dialog'].changeDialog(this.diffPayable)
        }
        else {
          this.dialogType = 0
          this.network().deliverEndorsement()
        }
      }

    },
    handlerDone() {
      // 區分是有報價還是無報價
    },
    handlerVoid(data){
      if(this.isCancel) {
        this.$refs['endorsement-info'].$refs['premium-form-endorsement'].updatePremium('save')
        this.network().voidSaveCancelQuote(data)
      }
      else {
        this.network().voidDeliverEndorsement(data)
      }
    },
    getData(personalData){
      this.personalData = personalData
    },
    network() {
      return {
        //TODO
        getEndorsementQuoteResult: async (params) => {
          this.$refs['use-personal-data'].handleSendData()
          // get_quote_main === refer 時需要傳
          params.plan_id = params.quote_coverage_list && params.quote_coverage_list.plan_info.plan_id||''
          const { data } = await getEndorsementQuoteResult({
            ...params,
            order_id: this.orderId,
            ticket_id: this.ticketId,
            marketing_data: this.personalData
          })
          const { is_null_new_data,type, diff_payable, new_premium, old_premium, extra_benefits_premium, is_manual_quote } = data
          this.isRefer = type === 2? true: false
          this.isNext = true
          this.premiumData = {
            diff_payable,
            new_premium,
            old_premium,
            extra_benefits_premium,
            type: type,
            is_manual_quote,
            is_null_new_data
          }
          this.diffPayable = diff_payable.payable
        },
        // save draft
        saveEndorsementQuote: async params => {
          delete params.application.credit
          params.application.marketing_data = this.personalData
          const { data } = await saveEndorsementQuote(params)
          this.initData()
          this.$emit('save')
        },
        editEndorsementQuote: async params => {
          delete params.application.credit
          params.application.marketing_data = this.personalData
          const { data } = await editEndorsementQuote(params)
          this.initData()
          this.$emit('save')
        },
        deliverEndorsement: async () => {
          let params = this.submitFormData
          delete params.application.credit
          params.application.content = this.content
          params.application.is_send = this.is_send
          params.application.marketing_data = this.personalData
          const { data } = await deliverEndorsement(params)
          // this.handlerDeliverDone()
          // this.$refs['send-email-sms'].changeDialog()
          this.$refs['deliver-dialog'].changeDialog()
        },
        getCancelQuoteResult: async params => {
          const { data } = await getCancelQuoteResult(params)
          this.isRefer = false
          this.isNext = true
          const { old_premium, diff_payable, remain_premium, extra_benefits_premium } = data
          this.premiumData = {
            old_premium,
            diff_payable,
            remain_premium,
            extra_benefits_premium
          }
          this.diffPayable = diff_payable.payable
        },
        saveCancelQuote: async (params = {}) => {
          const { data } = await saveCancelQuote({
            ...params,
            ticket_id: this.ticketId,
            order_id: this.orderId,
            pcy_expry_dt: this.resultForm.pcy_expry_dt,
            handling_fee: this.handlingFee,
            extra_benefits_content: this.premiumData.extra_benefits_premium
          })
          const { type } = params
          // save draft
          if(type == 1) {
            this.initData()
            this.$emit('save')
          }
          else {
            this.$refs['deliver-dialog'].changeDialog()
          }
        },
        voidDeliverEndorsement: async (params) => {
          const { data } = await deliverEndorsement({
            ...this.submitFormData,
            ...params
          })
          let type = ''
          type =params.refund_type==1?'cheque queue':'customer’s credits'
          this.$NewMessageBox({
            title: 'Endorsement',
            message: 'This endorsement has been completed. The refund amount has been ' +
              'added to the '+type,
            confirmBtn:'Done',
            btnType:'success'
          }).then(()=>{
            this.$emit('save')
          })

        },
        voidSaveCancelQuote: async (params) => {
          const { data } = await saveCancelQuote({
            type: 2,
            ...params,
            ...this.cancelParams,
            ...this.cancelData
          })
          let type = ''
          type ==params.refund_type==1?'cheque queue':'customer’s credits'
          this.$NewMessageBox({
            title: 'Endorsement',
            message: 'This endorsement has been completed. The refund amount has been ' +
              'added to the '+type,
            confirmBtn:'Done',
            btnType:'success'
          }).then(()=>{
            this.$emit('save')
          })
        }

      }
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-policy {
    position: relative;
    padding: 15px;
    .abs-top-right {
        top: 15px;
        right: 15px;
    }
  .width-remark-content{
    margin-right: 25px;
    width: calc(100% - 290px);
  }
    h2 {
      padding-bottom: 5px;
    }
    h2 + span {
      display: inline-block;
      padding-bottom: 10px;
    }
    .dialog-container {
      padding: 15px;
      p {
        padding-bottom: 15px;
      }
    }
}
</style>
